import { pick } from "lodash";

import { QuickShipsActions } from "../../types";

export function create(scheduleId: string, items: [any], form: any): any {
  const main = [
    "pickup_carrier",
    "pickup_vehicle_plate_number",
    "pickup_driver_name",
    "pickup_driver_phone_number",
    "pickup_vehicle_trailer_number",
    "carrier_tracking_number",
    "shipping_zone_id",
  ];

  const data = {
    door_id: form.door,
    reader_id: form.reader,
    printer_id: form.printer,
    crm_order_schedule: pick(form, main),
    items: items.map((item: any) => {
      return {
        item_number: item.item_number,
        tags: item.tags?.map((t: any) => t.epc_id) || [],
        override: item.override,
        override_reason: item.override_reason,
        wrong_item: item.wrong_item,
      };
    }),
  };

  return {
    types: QuickShipsActions.Create,
    method: "post",
    url: `api/v1/crm/schedules/${scheduleId}/quick_ships`,
    data,
  };
}

export function start(scheduleId: string, reader_id: string): any {
  return {
    types: QuickShipsActions.Start,
    method: "post",
    url: `api/v1/crm/schedules/${scheduleId}/quick_ships/start`,
    data: { reader_id },
  };
}

export function stop(scheduleId: string, reader_id: string): any {
  return {
    types: QuickShipsActions.Stop,
    method: "post",
    url: `api/v1/crm/schedules/${scheduleId}/quick_ships/stop`,
    data: { reader_id },
  };
}

export function print(scheduleId: string, printer_id: string): any {
  return {
    types: QuickShipsActions.Print,
    method: "get",
    url: `api/v1/crm/schedules/${scheduleId}/print`,
    params: { printer_id, copies: 1 },
  };
}
